import { useEventCallback } from '@cian/react-utils';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectOffersStatus } from 'shared/selectors/offers';
import { EOffersStatus } from 'shared/types/offers';

/**
 * Хук, который ждет, когда офферы загрузятся и после этого вызывается переданная трекинг-функция
 *
 * @param trackingFn - трекинг-функция
 * @returns функция, которая запускает трекинг после загрузки офферов
 */
export const useAwaitingTracking = (trackingFn: VoidFunction) => {
  const offersStatus = useSelector(selectOffersStatus);
  const isAwaitingTracking = useRef(false);

  useEffect(() => {
    if (offersStatus !== EOffersStatus.Pending && isAwaitingTracking.current) {
      trackingFn();

      isAwaitingTracking.current = false;
    }
  }, [offersStatus, trackingFn]);

  return useEventCallback(() => {
    isAwaitingTracking.current = true;
  });
};
